// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"0b6441f6","239":"9aac0e0e","453":"47f96c24","455":"8934d51a","977":"87497a42"}[chunkId] + ".chunk.js";
};